import React, { useCallback, useEffect, useState } from "react";
import BlockCard from "components/common/Card/BlockCard";
import styles from "./index.module.scss";
import Block from "components/Block";
import BlockSkeleton from "components/Block/BlockSkeleton";
import BlockCardSkeleton from "components/common/Card/BlockCard/BlockCardSkeleton";
import { emptyBlocks } from "mocks/emptyBlocks";
import { useLifeChoices } from "store/api/LifeChoiceBlocks";
// import { Waypoint } from "react-waypoint";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import InfiniteScroll from "react-infinite-scroll-component";

const Blocks = () => {
  const [page, setPage] = useState(1);
  const [blocks, setBlocks] = useState([]);

  const { data, isLoading, hasMore } = useLifeChoices({ page });
  const { dir, language } = useAppSelector(getSettings);

  useEffect(() => {
    if (data) {
      setBlocks((prev) => prev.concat(data));
    }
  }, [data]);

  const renderItem = useCallback(
    (block) => (block ? <BlockCard item={block} /> : <BlockCardSkeleton />),
    []
  );

  return (
    <div
      className={`${styles["blocks-wrapper"]} | container-right-aligned`}
      dir={dir}
      lang={language}
    >
      <ul role="list" className={`${styles["blocks-section"]} mt-5`}>
        <InfiniteScroll
          dataLength={blocks.length}
          next={() => {
            if (!isLoading) {
              setPage(page + 1);
            }
          }}
          hasMore={hasMore}
          loader={
            <BlockSkeleton
              item={emptyBlocks[0]}
              carouselItemRender={renderItem}
            />
          }
        >
          {data
            ? blocks.map((block, idx) => (
                <li key={block.category._id + `-${idx}`}>
                  <div>
                    <Block
                      block={block}
                      carouselItemRender={renderItem}
                      carouselOptions={{
                        sliderBtns: true,
                      }}
                    />
                  </div>
                </li>
              ))
            : emptyBlocks.map((emptyBlock, idx) => (
                <li key={`--empty-block-${idx}`}>
                  <BlockSkeleton
                    carouselItemRender={renderItem}
                    item={emptyBlock}
                  />
                </li>
              ))}
        </InfiniteScroll>
      </ul>
    </div>
  );
};

export default Blocks;
